import React from 'react';
import PropTypes from 'prop-types';
import BaseCell from '../base-cell/index';
import AvatarIcon from '../../../common/avatarIcon';
import Icon from '@mdi/react';
import { mdiFilePdfBox } from '../../../../images/svg';

export default class PDFCell extends BaseCell {
  render() {

    const {isBot, baseParams, url, time, iconSrc, withoutDate, additional_url, fileName} = this.props;
    const { avatarStyle } = this.getCellStyle({isBot, baseParams, iconSrc});

    return (
      <div className={this.messageClass(isBot)}>
        <div className={'cu-ui-message-block cu-ui-text-count-data'} { ...this.textCountCustomAttributes }>
          <div className={'cu-ui-message-avatar'} style={avatarStyle}>
            { !(isBot || iconSrc && iconSrc.length !== 0) && <AvatarIcon />}
          </div>
          <div className={'cu-ui-message-content cu-ui-message-pdf'} tabIndex="0">
            <Icon
              className="pdf-icon"
              path={mdiFilePdfBox}
            />
            <a href={url} target="_blank">{fileName ? fileName : url}</a>
          </div>
        </div>
        {
          !withoutDate && <div className={'cu-ui-message-time'}>{time}</div>
        }
      </div>
    );
  }
}

PDFCell.propTypes = {
  url: PropTypes.string,
  time: PropTypes.string,
  isBot: PropTypes.bool,
  iconSrc: PropTypes.string
};
